import { isTestUser } from "utils/helper";

export const getProspectUuid = () => {
  const uuid = localStorage.getItem("uuid");
  return uuid || "";
};

export const getCompanyId = () => {
  if (isTestUser) {
    return "test-user-flow";
  }
  const companyId = localStorage.getItem("companyId");
  return companyId || "";
};

export const getMemberUuid = () => {
  const memberUuid = localStorage.getItem("memberUuid");
  return memberUuid || "";
};

export const getProspectCanonicalId = () => {
  const prospectCanonicalId = localStorage.getItem("canonicalId");
  return prospectCanonicalId || "";
};
